import { apiFetch } from "./client";

export type BillingCycle = "monthly" | "quarterly" | "yearly";

export interface PricingPlan {
  id: string;
  merchantId: string;
  name: string;
  validFrom: string;
  validUntil: string | null;
  monthlyFee: string;
  monthlyFeeCurrency: string;
  txFeeFixed: string;
  txFeePercentage: string;
  txFeeCurrency: string;
  includedTxPerMonth: number | null;
  overQuotaTxFee: string | null;
  billingCycle: BillingCycle;
  free: boolean;
  selfBillingEnabled: boolean;
  active: boolean;
  createdAt: string;
}

export interface CreatePricingPlanInput {
  name: string;
  monthlyFee: number;
  monthlyFeeCurrency?: string;
  txFeeFixed: number;
  txFeePercentage: number;
  txFeeCurrency?: string;
  includedTxPerMonth?: number;
  overQuotaTxFee?: number;
  billingCycle?: BillingCycle;
  free?: boolean;
  selfBillingEnabled?: boolean;
}

export const listPricingPlans = (merchantId: string) =>
  apiFetch<PricingPlan[]>(`/admin/merchants/${merchantId}/pricing-plans`);

export const getActivePricingPlan = (merchantId: string) =>
  apiFetch<PricingPlan | null>(
    `/admin/merchants/${merchantId}/pricing-plans/active`,
  );

export const createPricingPlan = (
  merchantId: string,
  body: CreatePricingPlanInput,
) =>
  apiFetch<PricingPlan>(`/admin/merchants/${merchantId}/pricing-plans`, {
    method: "POST",
    body,
  });

export const expirePricingPlan = (merchantId: string, planId: string) =>
  apiFetch<PricingPlan>(
    `/admin/merchants/${merchantId}/pricing-plans/${planId}/expire`,
    { method: "POST" },
  );
